import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import Results from './pages/Results';
import Gallery from './pages/Gallery';
import Store from './pages/Store';
import Admin from './pages/Admin';
import ViewerLogin from './pages/ViewerLogin';
import ViewerDashboard from './pages/ViewerDashboard';
import Layout from './components/Layout';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/results" element={<Results />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/store" element={<Store />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/viewer/login" element={<ViewerLogin />} />
          <Route path="/viewer" element={<ViewerDashboard />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;